export default __webpack_public_path__ + "static/media/pointOfService.1e7e6e7c.svg";